/*---------------------------------------------------------------------------
									SITE FOOTER FUNCTIONS STARTS
			----------------------------------------------------------------------------*/

function overAllSiteFooterFunctions() {
    var $countryId = $('#countryId'),
        $countrylist = $('.wcs-countryClass'),
        $countryclose = $('#countryCloseButton'),
        $help = $('#helpId'),
        $helplist = $('.wcs-helpClass'),
        $helpclose = $('#helpCloseButton'),
        $contactuslink = $("#wcs_contact_us"),
        $contactuscontent = $("#wcs_contact_us_content"),
        $contactusclose = $('#wcs_contact_us_close'),
        $socialIconDiv = $('.rb-footer-social'),
        $openSeoLinkArea = $('#openSeoLinks'),
        $win = $(window),
        $seoLinkArea = $('.wcs-all-sites-area'),
        $closeIcon = $('#wcs-close-link'),
        $wcsCountryDivs = $('.wcs-country div'),
        $wcsContinentDivs = $('.wcs-continent div'),
        $htmlBody = $('html, body'),
        $document = $(document);

    // click functionality for opening footer for country.
    $countryId.next().off("click.wcs").on("click.wcs", function(e) {
        $countryId.trigger("click");
    });

    window.selected_country_value = function() {
        var selected_country = $('#wcsCoutryAndLangId').val();
        if(!selected_country){
            return;
        }
        var langCountry=selected_country.replace('_','-');
        if(langCountry=='en-PL'){
            langCountry='pl-PL';
        } else if(langCountry=='en-PT'){
            langCountry='pt-PT';
        }else if(langCountry=='en-NL'){
            langCountry='nl-NL';
        }else if(langCountry=='en-FI'){
            langCountry='fi-FI';
        }
        var $sel = $('a[lang="'+langCountry+'"]');
        $sel.addClass('wcs-color-active-country');
        $countryId.html($sel.text());
    };
    selected_country_value();

    var fadein_fadeout_country = function(obj) {
        if ($(obj).is('.wcs-white')) {
            $countryId.parent().addClass('wcs-dim');
        } else {
            $countryId.parent().removeClass('wcs-dim');
        }
    };

    $countryId.off("click.wcs").on("click.wcs", function(e) {
        $help.removeClass('open');
        $contactuslink.removeClass('open');
        $countryId.toggleClass('open');
        if($('.rb-footer-social.wcs-hide').length) {
            $socialIconDiv.removeClass('wcs-hide');
        } else {
            $socialIconDiv.addClass('wcs-hide');
        }

        e.preventDefault();
        //Analytics end
        if ($helplist.is(":visible") && $contactuscontent.is(":visible")) {
            $($helplist, $countrylist).slideToggle(function() {
                $countrylist.slideToggle();
            });
        } else if ($helplist.is(":visible")) {
            $helplist.slideToggle(function() {
                $countrylist.slideToggle();
            });
        } else if ($contactuscontent.is(":visible")) {
            $contactuscontent.slideToggle(function() {
                $countrylist.slideToggle();
                $countryId.parent().removeClass("wcs-dim");
            });
        } else {
            $countrylist.slideToggle();
        }

        $contactuslink.removeClass('wcs-white');
        $help.removeClass('wcs-white');
        //now scroll the page to wrapper
        setTimeout(function(){
            if($('.wcs-mapcontainer.wcs-selected').length){
                $htmlBody.animate({
                    scrollTop: $countrylist.offset().top - 60
                }, 1000);
            }
        }, 1000);
    });

    $countryclose.off("click.wcs").on("click.wcs", function(e) {
        $countryId.removeClass("open");
        e.preventDefault();
        $countrylist.slideToggle();
        $socialIconDiv.removeClass('wcs-hide');
    });

    function toggleContactForm(){
        var $contactUsContentForm = $contactuscontent.find('.wcs-contactus-form');
        $contactuscontent.find('.wcs-contact-us-success').addClass('wcs-hide');
        $contactUsContentForm.removeClass('wcs-hide').find('input[type="text"],input[type="email"], textarea').removeClass('ui-state-valid').val('');
        $contactUsContentForm.find('input.wcs-dropdown-text').val('Please select').addClass('wcs-dropdown-validation').removeClass('ui-state-valid');
        $contactuscontent.slideToggle();
    }

    $contactuslink.off("click.wcs").on("click.wcs", function(e) {
        $contactuslink.toggleClass('open');
        $help.removeClass('open');
        $countryId.removeClass('open');
        fadein_fadeout_country($contactuslink);

        setTimeout(function () {
            if ($('.wcs-new-contact-us-design').length) {
                $htmlBody.animate({
                    scrollTop: $contactuscontent.offset().top - 60
                }, 1000);
            }
        }, 1000);

        e.preventDefault();
        if ($helplist.is(":visible") && $countrylist.is(":visible")) {
            $($helplist, $countrylist).slideToggle(function() {
                toggleContactForm();
            });

        } else if ($countrylist.is(":visible")) {
            $countrylist.slideToggle(function() {
                toggleContactForm();
            });
        } else if ($helplist.is(":visible")) {
            $helplist.slideToggle(function() {
                toggleContactForm();
            });
        } else {
            toggleContactForm();
        }
        //formValidation_onBlur();
        //Close contact popup
        $contactusclose.off("click.wcs").on("click.wcs", function(e) {
            var $contact_us_form_row = $('#contact_us_form').find('.wcs-row');
            $contactuscontent.slideToggle();
            $contactuslink.removeClass("open");

            $contact_us_form_row.find('.wcs-error-message').removeClass('wcs-show');
            $contact_us_form_row.removeAttr('style');
            $contact_us_form_row.find(".exclamatory").hide();
            $contact_us_form_row.find('.ui-state-error').removeClass('ui-state-error');

            fadein_fadeout_country($contactuslink);
            e.preventDefault();
        });
    });

    //merging help arrow object to help object.
    $.merge($help, $help.next());

    $help.off("click.wcs").on("click.wcs", function(e) {
        $countryId.removeClass('open');
        $contactuslink.removeClass('open');
        $help.toggleClass('open');
        fadein_fadeout_country($help);

        e.preventDefault();
        if ($countrylist.is(":visible") && $contactuscontent.is(":visible")) {
            $countrylist.slideToggle(function() {
                $helplist.slideToggle();
            });
        } else if ($countrylist.is(":visible")) {
            $countrylist.slideToggle(function() {
                $helplist.slideToggle();
            });
        } else if ($contactuscontent.is(":visible")) {
            $contactuscontent.slideToggle(function() {
                $helplist.slideToggle();
            });
        } else {
            $helplist.slideToggle();

        }
        return false;
    });

    $helpclose.off("click.wcs").on("click.wcs", function(e) {
        $helplist.slideToggle();
        $help.removeClass('open');
        fadein_fadeout_country($help);
        e.preventDefault();
    });

    var charLength;
    window.charCount = function() {
        $('textarea.wcs-charCount').keyup(function(e) {
            currObj = $(this);
            maxlength = currObj.attr('maxlength');
            charLength = currObj.val().length;
            var newLines = currObj.val().match(/(\r\n|\n|\r)/g);
            var total_length;
            if (WcsBrowser.isChrome) {
                if (newLines) {
                    total_length = charLength + newLines.length;
                } else {
                    total_length = charLength;
                }
            } else {
                total_length = charLength;
            }

            if (charLength <= maxlength) {
                currObj.parent('div').find('.wcs-charCount-span').text(maxlength - total_length);
            } else {
                e.preventDefault();
            }
        });
    };
    charCount();

    $document.ready(function(){
        if($countryId.length){
            var text = $countryId.text().trim();
            var countryListArray = window.countriesListData.continents;

            $.map( countryListArray, function( val, index ) {
                var indexChild = $.map(val.locales, function(locale) { return locale.label }).indexOf(text);
                if(indexChild != -1){
                    $wcsContinentDivs.eq(index).addClass('wcs-selected');
                    $wcsCountryDivs.eq(index).show();
                }
            });
        }
    });

    $('.wcs-continent-wrapper .wcs-continent div.wcs-mapcontainer').on("click", function() {
        var current = $(this).index();
        $wcsContinentDivs.removeClass('wcs-selected').removeClass('wcs-hover');
        $wcsContinentDivs.addClass('wcs-hover');
        $wcsContinentDivs.eq(current).removeClass('wcs-hover').addClass('wcs-selected');
        $wcsCountryDivs.hide();
        $wcsCountryDivs.eq(current).show();
    });

    window.wcsIconTipHandler=function(){
        $('a.wcs-icon-tip').off('mouseover touchstart mouseout').on('mouseover touchstart',function(e){
            e.stopPropagation();
            $(this).find('.wcs-notification-box').removeClass('wcs-hidden');
            $document.off('touchstart.tip').on('touchstart.tip', function(){
                $('a.wcs-icon-tip .wcs-notification-box').addClass('wcs-hidden');
                $document.off('touchstart.tip');
            });
        }).on('mouseout',function(){
            $(this).find('.wcs-notification-box').addClass('wcs-hidden');
        });
    };
    wcsIconTipHandler();

    //  functionality for seol links
    $openSeoLinkArea.on('click', function(e) {
        e.preventDefault();
        $seoLinkArea.removeClass('wcs-hide');
    });
    $win.on('click', function(event){
        if ($seoLinkArea.length && !$openSeoLinkArea.has(event.target).length === 0 && $openSeoLinkArea.is(event.target)) {
            $seoLinkArea.addClass('wcs-hide');
            $htmlBody.animate({
              scrollTop: $seoLinkArea.offset().top - $('.wcs-hd-container').height()
            }, 'slow');
        }
    });
    $closeIcon.on('click', function(e) {
        e.preventDefault();
        $seoLinkArea.addClass('wcs-hide');
    });
}
/*---------------------------------------------------------------------------
									SITE FOOTER FUNCTIONS ENDS
			----------------------------------------------------------------------------*/
